<template>
    <floating-form
        :label="trans('generic.search')"
        class="dropdown mb-0 mr-3"
        label-for="search"
    >

        <b-form-input
            id="search"
            ref="search"
            v-model="search"
            autocomplete="off"
            debounce="500"
            type="search"
            size="sm"
            :placeholder="trans('generic.search')"
            @focus="onInputFocus"
            @blur="onInputBlur"
        ></b-form-input>

        <ul
            :id="dropdownId"
            :ref="dropdownId"
            class="dropdown-menu dropdown-menu-right p-4 mt-2"
            :class="{show: showDropdown}"
            tabindex="-1"
            @blur="onDropdownBlur"
        >
            <li v-for="result of results" :key="result.href" class="d-flex">
                <span class="text-nowrap mr-4 mb-1">{{ result.text }}</span>
                <link-layout icon="arrow-right" class="ml-auto" @click="goto(result.href, result.popout)" @blur="onBlur">
                    <template #start>
                        <span class="mr-2">{{ result.type }}</span>
                    </template>
                </link-layout>
            </li>
            <li v-if="!isBusy && results.length === 0" class="d-flex">
                <span class="text-nowrap">{{ trans('generic.no_results_found') }}</span>
            </li>
        </ul>
    </floating-form>
</template>

<script>
import FloatingForm from "@/shared/FloatingForm.vue"
import LinkLayout from "@/shared/LinkLayout.vue"

export default {
    components: {
        FloatingForm,
        LinkLayout,
    },
    props: {
        apiUrl: String,
    },
    data: () => ({
        dropdownId: 'global-search-menu',
        search: null,
        results: [],
        hasFocus: false,
        isBusy: false,
    }),
    computed: {
        showDropdown() {
            return this.search && this.search.length && this.hasFocus && !this.isBusy
        },
    },
    watch: {
        search(value) {
            this.getResults(value)
        },
    },
    methods: {
        onInputFocus() {
            this.hasFocus = true
        },
        onBlur(event) {
            setTimeout(() => {
                const dropdown = this.$refs[this.dropdownId]
                if (!dropdown.contains(event.relatedTarget) && event.relatedTarget !== document.activeElement) {
                    this.hasFocus = false
                }
            })
        },
        onInputBlur(event) {
            this.onBlur(event)
        },
        onDropdownBlur(event) {
            this.onBlur(event)
        },
        getResults(search) {
            this.results = []
            if (search) {
                this.isBusy = true
                const url = this.apiUrl + '/' + search
                axios.get(url)
                    .then(({data}) => {
                        this.results = data.data
                    })
                    .finally(() => {
                        this.isBusy = false
                    })
            }
        },
        goto(href, popout = false) {
            this.hasFocus = false
            if (popout) {
                window.open(href, '_blank')
            } else {
                this.$inertia.get(href)
            }
        },
    },
}
</script>
